// apiService.js
(() => {
  const baseUrl = (() => {
    const host = location.hostname;
    if (host.includes("localhost") || host.includes("ibwt.com.tw")) {
      return "https://ncapi.ibwt.com.tw/Shop";
    } else {
      return "https://ncapi.bwt.com.tw/Shop";
    }
  })();
  // 創建一個模擬的axios客戶端
  const apiClient = {
    //baseUrl: "http://localhost:5155",
    //baseUrl: "https://ncapi.ibwt.com.tw/Shop",
    baseUrl,
    get(url) {
      return fetch(this.baseUrl + url).then((response) => {
        if (!response.ok) throw new Error("API請求失敗");
        return response.json();
      });
    },
    post(url, data) {
      return fetch(this.baseUrl + url, {
        method: "POST",
        headers: {
          accept: "text/plain",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }).then((response) => {
        if (!response.ok) throw new Error("API請求失敗");
        return response.json();
      });
    },
    getMainGroupInfoByWebSite(shopCode) {
      return this.get(`/Present/GetMainGroupInfoByWebSite/${shopCode}`);
    },
    getMainGroupInfoByWebSiteSSE(
      shopCode,
      setDataSource,
      setBaseSource,
      callbacks = {},
    ) {
      const url = `${this.baseUrl}/Present/GetMainGroupInfoByWebSiteSSE/${shopCode}`;
      const streamStartedAt = performance.now();
      const stepMetrics = {};
      let mainGroupData = [];
      let streamClosed = false;
      let processing = false;
      let totalReceivedBytes = 0;
      let baseSourceReady = false;
      let primaryReadyCalled = false;
      let completeCalled = false;
      let flushScheduled = false;
      let rafId = null;
      const lineQueue = [];

      const { onPrimaryReady = () => {}, onComplete = () => {} } = callbacks;

      // 建立 AbortController 用於取消請求
      const controller = new AbortController();
      const signal = controller.signal;

      const runPrimaryReadyOnce = () => {
        if (primaryReadyCalled) return;
        primaryReadyCalled = true;
        onPrimaryReady();
      };

      const runCompleteOnce = () => {
        if (completeCalled) return;
        completeCalled = true;
        onComplete();
      };

      const finalizeIfReady = () => {
        if (
          !streamClosed ||
          processing ||
          lineQueue.length > 0 ||
          !baseSourceReady
        ) {
          return;
        }
        runCompleteOnce();
      };

      const flushDataSource = () => {
        rafId = null;
        flushScheduled = false;
        setDataSource(mainGroupData);
      };

      const scheduleSetDataSource = () => {
        if (!flushScheduled) {
          flushScheduled = true;
          if (typeof window.requestAnimationFrame === "function") {
            rafId = window.requestAnimationFrame(flushDataSource);
          } else {
            Promise.resolve().then(flushDataSource);
          }
        }
      };

      const processLine = async (line) => {
        if (line.startsWith("data: ")) {
          const data = line.slice(6); // 移除 'data: ' 前綴
          if (data === "[DONE]") {
            streamClosed = true;
            finalizeIfReady();
            return;
          }

          try {
            const parsedData = JSON.parse(data);
            const stepStartedAt = performance.now();
            switch (parsedData.step) {
              case "step1":
                mainGroupData = parsedData.data;
                setDataSource(mainGroupData);
                break;
              case "step2":
                mainGroupData = mainGroupData.map((mainGroup) => {
                  const item = parsedData.data.find(
                    (item) => item.mainGroupCode === mainGroup.mainGroupCode,
                  );
                  if (item) {
                    mainGroup.groups = item.groups.map((group) => ({
                      ...group,
                      groupName: group.groupName || mainGroup.groupName,
                    }));
                    mainGroup.departure = item.departure;
                  }
                  return mainGroup;
                });
                break;
              case "step3":
                mainGroupData = mainGroupData.filter(
                  (item) =>
                    item.groups.filter((group) => group.price === 99999999)
                      .length === 0,
                );
                if (
                  rafId !== null &&
                  typeof window.cancelAnimationFrame === "function"
                ) {
                  window.cancelAnimationFrame(rafId);
                  rafId = null;
                }
                flushScheduled = false;
                setDataSource(mainGroupData);
                Promise.resolve(setBaseSource(mainGroupData))
                  .catch((e) => {
                    console.error("setBaseSource 執行錯誤:", e);
                  })
                  .finally(() => {
                    baseSourceReady = true;
                    runPrimaryReadyOnce();
                    finalizeIfReady();
                  });
                break;
            }

            if (parsedData.step) {
              const stepEndedAt = performance.now();
              stepMetrics[parsedData.step] = {
                sinceStartMs: stepStartedAt - streamStartedAt,
                durationMs: stepEndedAt - stepStartedAt,
              };
              console.log(
                `[Destination SSE] ${parsedData.step} reached in ${stepMetrics[
                  parsedData.step
                ].sinceStartMs.toFixed(1)} ms, handled in ${stepMetrics[
                  parsedData.step
                ].durationMs.toFixed(1)} ms`,
              );
            }
          } catch (e) {
            console.error("解析資料錯誤:", e);
          }
        } else if (line.startsWith("event: ")) {
          const eventType = line.slice(7); // 移除 'event: ' 前綴
          if (eventType === "complete") {
            streamClosed = true;
            finalizeIfReady();
          }
        }
      };

      const processQueue = async () => {
        if (processing) return;
        processing = true;

        try {
          while (lineQueue.length > 0) {
            const line = lineQueue.shift();
            await processLine(line);
          }
        } finally {
          processing = false;
          if (lineQueue.length > 0) {
            void processQueue();
          } else {
            finalizeIfReady();
          }
        }
      };

      // 使用 fetch 搭配 ReadableStream 實現 SSE
      fetch(url, {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        signal: signal, // 加入 signal 用於取消請求
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = "";

          function readStream() {
            return reader.read().then(({ done, value }) => {
              if (done) {
                streamClosed = true;
                console.log(
                  `[Destination SSE] GetMainGroupInfoByWebSiteSSE received ${(
                    totalReceivedBytes / 1024
                  ).toFixed(2)} KB in ${(
                    performance.now() - streamStartedAt
                  ).toFixed(1)} ms`,
                );
                if (Object.keys(stepMetrics).length > 0) {
                  console.log("[Destination SSE] step metrics", stepMetrics);
                }
                if (!baseSourceReady) {
                  baseSourceReady = true;
                }
                finalizeIfReady();
                return;
              }

              totalReceivedBytes += value?.byteLength || 0;
              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split("\n");
              buffer = lines.pop(); // 保留不完整的行

              if (lines.length > 0) {
                lineQueue.push(...lines);
                void processQueue();
              }

              return readStream(); // 繼續讀取
            });
          }

          return readStream();
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("請求已被取消");
          } else {
            console.error("SSE 連接錯誤:", error);
          }
        });

      // 返回取消函數，讓呼叫者可以取消請求
      return () => {
        if (
          rafId !== null &&
          typeof window.cancelAnimationFrame === "function"
        ) {
          window.cancelAnimationFrame(rafId);
        }
        controller.abort();
      };
    },
    getShopDetailByWebSite(websiteId) {
      return this.get(`/Present/GetShopDetailForPresent/${websiteId}`);
    },
    getTopBannerByCode(shopSn) {
      return this.get(`/Present/GetTopBannerByCode/${shopSn}`);
    },
    getMarketingActivitiesByCode(shopSn) {
      return this.get(`/Present/GetMarketingActivitiesByCode/${shopSn}`);
    },
    getFlightsByGroupCode(groupCode) {
      return this.get(`/Present/GetFlightsByGroupCode/${groupCode}`);
    },
    getCruPriceByGroupCode(mainGroupCode, groupCode) {
      return this.get(
        `/Present/GetCruPriceByGroupCode/${mainGroupCode}/${groupCode}`,
      );
    },
    getFollowedItemsByCode(shopSn) {
      return this.get(`/Present/GetFollowedItemsByCode/${shopSn}`);
    },
    getHistoryByGroupCode(mainGroupCode) {
      return this.post(`/Present/GetSearchInfo`, {
        mainGroupCode: mainGroupCode,
        areaCode: "",
        startDate: "",
        endDate: "",
        soon: "",
        signUp: "",
        guarantee: "",
        airPt: "",
        keyword: "",
      });
    },
    getSearchInfo(
      mainGroupCode,
      areaCode,
      startDate,
      endDate,
      soon,
      signUp,
      guarantee,
      airPt,
    ) {
      return this.post(`/Present/GetSearchInfo`, {
        mainGroupCode: mainGroupCode,
        areaCode: areaCode,
        startDate: startDate,
        endDate: endDate,
        soon: soon,
        signUp: signUp,
        guarantee: guarantee,
        airPt: airPt,
      });
    },
    getSearchInfoSSE(
      mainGroupCode,
      areaCode,
      startDate,
      endDate,
      soon,
      signUp,
      guarantee,
      airPt,
      keyword,
      setDataSource,
      callback,
    ) {
      // 建構 POST 資料
      const postData = {
        mainGroupCode: mainGroupCode,
        areaCode: areaCode,
        startDate: startDate,
        endDate: endDate,
        soon: soon,
        signUp: signUp,
        guarantee: guarantee,
        airPt: airPt,
        Keyword: keyword,
      };

      const url = `${this.baseUrl}/Present/GetSearchInfoSSE`;
      let searchData = [];
      let mainGroupData = [];

      // 建立 AbortController 用於取消請求
      const controller = new AbortController();
      const signal = controller.signal;

      // 使用 fetch 搭配 ReadableStream 實現 POST SSE
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "text/event-stream",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(postData),
        signal: signal, // 加入 signal 用於取消請求
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body.getReader();
          const decoder = new TextDecoder();
          let buffer = "";

          function readStream() {
            return reader.read().then(({ done, value }) => {
              if (done) {
                callback();
                return;
              }

              buffer += decoder.decode(value, { stream: true });
              const lines = buffer.split("\n");
              buffer = lines.pop(); // 保留不完整的行

              lines.forEach((line) => {
                if (line.startsWith("data: ")) {
                  const data = line.slice(6); // 移除 'data: ' 前綴
                  if (data === "[DONE]") {
                    callback();
                    return;
                  }

                  try {
                    const parsedData = JSON.parse(data);
                    searchData = parsedData.data;

                    switch (parsedData.step) {
                      case "step1":
                        mainGroupData = searchData;
                        setDataSource(searchData);
                        break;
                      case "step2":
                        mainGroupData = mainGroupData.map((mainGroup) => {
                          const item = searchData.find(
                            (item) =>
                              item.mainGroupCode === mainGroup.mainGroupCode,
                          );
                          if (item) {
                            mainGroup.groups = item.groups;
                            mainGroup.departure = item.departure;
                          }
                          return mainGroup;
                        });
                        setDataSource(mainGroupData);
                        break;
                      case "step3":
                        mainGroupData = mainGroupData.filter(
                          (item) =>
                            item.groups.filter(
                              (group) => group.price === 99999999,
                            ).length === 0,
                        );
                        setDataSource(mainGroupData);
                        callback();
                        break;
                    }
                  } catch (e) {
                    console.error("解析資料錯誤:", e);
                  }
                } else if (line.startsWith("event: ")) {
                  const eventType = line.slice(7); // 移除 'event: ' 前綴
                  if (eventType === "complete") {
                    callback();
                    return;
                  }
                }
              });

              return readStream(); // 繼續讀取
            });
          }

          return readStream();
        })
        .catch((error) => {
          if (error.name === "AbortError") {
            console.log("請求已被取消");
          } else {
            console.error("SSE 連接錯誤:", error);
          }
        });

      // 返回取消函數，讓呼叫者可以取消請求
      return () => {
        controller.abort();
      };
    },
    getAllAirline() {
      return this.get(`/Present/GetAllAirline`, {});
    },
    getAirports() {
      return this.get(`/Present/GetAirports`, {});
    },
    getCorrespond() {
      return this.get(`/Present/GetCorrespond`, {});
    },
    getGroupTags(shopSn) {
      return this.get(`/Present/GetGroupTags/${shopSn}`);
    },
    getClassification() {
      return this.get(`/Present/GetClassification`, {});
    },
    getSubClassification() {
      return this.get(`/Present/GetSubClassification`, {});
    },
    async getCompanyInfo(webSite) {
      let url = "";
      const host = location.hostname;
      if (
        host.includes("localhost") ||
        host.includes("ibwt.com.tw") ||
        host.includes("bbctour.com.tw")
      ) {
        url = `https://ncapi.ibwt.com.tw/dm/GetCompanyInfo/${webSite}`;
      } else {
        url = `https://ncapi.bwt.com.tw/dm/GetCompanyInfo/${webSite}`;
      }

      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    },
  };

  window.apiClient = apiClient;
})();
